import ErrorOutlineIcon from '@portalterreno/react-ui-icons/ErrorOutlineIcon';

import IconWrapper from './IconWrapper';
import StyledDiv from './StyledDiv';

export type AlertProps = React.PropsWithChildren<
  React.HtmlHTMLAttributes<HTMLDivElement>
> & {
  icon?: React.ReactNode;
};

const Alert: React.FC<AlertProps> = ({
  children,
  icon = <ErrorOutlineIcon />,
  ...rest
}) => {
  return (
    <StyledDiv {...rest}>
      <IconWrapper>{icon}</IconWrapper>
      <div>{children}</div>
    </StyledDiv>
  );
};

export default Alert;
